import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MenuItemModel } from 'src/Models/MenuItemModel';
import { MenuMasterModel } from 'src/Models/MenuMasterModel';
import { MenuService } from 'src/Services/menu.service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  tokenKey: string = '';
  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  menuItems = new Array<MenuItemModel>();
  dropdownListMenu = new Array<MenuMasterModel>();
  selectedMenu: any;
  loginuserID: any;
  dropdownSettingsMenu = {};
  isloadingmenu = false;
  SelectedTool = '';
  openMenuIndex: number = -1;

  constructor(private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly router: Router,
    private readonly menuService: MenuService,
    private readonly toastrService: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {

    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.loginuserID = this.sessionStorageService.getAdminUserId();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('Menus');
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
  }

  ngOnInit() {
    this.movetotop();
    this.dropdownSettingsMenu = {
      singleSelection: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No menu available',
      primaryKey: 'menuGroupId',
      labelKey: 'menuGroupName',
      text: 'Select menu group',
    };
    this.getMenuGroup();
    this.getMenuItem();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  getMenuGroup() {
    this.menuService.i360MenuGroupAdminGet(this.tokenKey).subscribe(data => {
      if (data) {
        if (data.status == "Success") {
          this.dropdownListMenu = data.listOfMenu;
        }
        else {
          this.toastrService.error("Error", "error");
        }
      }
    })
  }

  getMenuItem(menuGroupId = 0) {
    this.isloadingmenu = true;
    this.menuService.i360MenuItems(this.tokenKey, menuGroupId).subscribe(data => {
      this.isloadingmenu = false;
      if (data) {
        if (data.status == "Success") {
          this.menuItems = data.listOfMenu;
        }
        else {
          this.toastrService.error("Error", "error");
        }
      }
    }, error => {
      this.isloadingmenu = false;
    })
  }

  onMenuSelect(selectedMenu) {
    this.menuItems = [];
    if (this.selectedMenu.length > 0 && selectedMenu.length != 0) {
      this.getMenuItem(this.selectedMenu[0].menuGroupId);
    }
    else
      this.getMenuItem();
  }

  editMenu(menuId) {
    let toolName = this.SelectedTool == 'actionitem' ? 'trac-it' : this.SelectedTool;
    this.router.navigate(['/admin/' + toolName + '/menu/edit/' + menuId]);
  }

  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportMenu() {

    if (this.menuItems.length > 0) {
      let tableData = document.getElementById("Exportmenu").innerHTML;

      var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
        , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
      let html = "<table><tr class='mainhead'> <td colspan='3'>";
      html += tableData;
      html += "</td></tr></table>";
      let name = 'ExportAdminMenus';
      var ctx = { worksheet: name || 'Worksheet', table: html }
      FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportAdminMenus.xls");
    }
    else {
      this.toastrService.error("No record found", "Error");
    }
  }
}